import React from "react";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import { mdiLogout } from "@mdi/js";
import Icon from "@mdi/react";
import logo from "../../../assets/logo.png";
import "./Header.scss";
import AUX from "../../../hoc/AU-X/AU-X";
import Drawer from "../../React-Drawer";
import useWindowDimensions from "../../../hooks/WindowDimensions";
import { changeTab } from "../../../store";
import { useDispatch } from "react-redux";

const allLinks = [
  { title: "خانه", url: "/" },
  { title: "لیست داده ها", url: "/ListView" },
  { title: "نقشه", url: "/Map" },
  { title: "درباره داده ها", url: "/AboutData" },
  { title: "راهنما", url: "/Guideline" },
];

const Header = (props) => {
  const location = useLocation();
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  return (
    <AUX>
      <div className="header">
        <div className="center">
          <img src={logo} alt="" />
          <h2>سامانه پایش دینامیک دریاچه ارومیه</h2>
        </div>
        <NavLink to="/logout">
          <Icon path={mdiLogout} size={1.3} title="logout" />
        </NavLink>
      </div>
      <div className="lowerHeader">
        <ul>
          {allLinks.map((link, index) => (
            <li
              key={index.toString()}
              className={location.pathname === link.url ? "current" : ""}
              onClick={() => dispatch(changeTab(index))}
            >
              {/* <NavLink className={location.pathname.indexOf(link.url) !== -1 ? 'current' : ''} to={link.url}> */}
              <NavLink to={link.url}>{link.title}</NavLink>
            </li>
          ))}
        </ul>
        {location.pathname === "/Map" && width < 450 ? (
          <div style={{ display: "flex", flexDirection: "row-reverse" }}>
            <Drawer>{props.UI}</Drawer>
          </div>
        ) : null}
      </div>
    </AUX>
  );
};

export default Header;
